import { Box, useTheme } from "@mui/material";
import { Breadcrumb } from '../global';
import { H2 } from "../global";

const Header = ({ title, module, subtitle, icon }) => {
    return (
        <Box>
            <Breadcrumb />
        </Box>
    );
};

const DetailsHeader = ({ title, icon }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                mb: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
            }}
        >
            {icon && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                    }}
                >
                    {icon}
                </Box>
            )}
            <H2
                sx={{
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                }}
            >
                {title}
            </H2>
        </Box>
    );
};

export { Header, DetailsHeader };